export default {"src":"/_next/static/media/juggle.colour.c2a19d9f.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};